import { createRouterSelector } from '@atlassian/react-resource-router/src/controllers/router-store';
import { useSubProduct } from '@jira/platform__services-subproduct/src/index.tsx';

const ROVO_ONBOARDING_TARGET_ROUTES = new Set([
	'software-boards',
	'software-backlog',
	'software-list',
]);

// oxlint-disable-next-line typescript/no-invalid-void-type
export const useIsTargetRouteName: (args_0: void) => boolean = createRouterSelector((state) =>
	ROVO_ONBOARDING_TARGET_ROUTES.has(state.route.name),
);

/**
 * Returns whether the current page is a valid target for the Rovo for Jira onboarding experiment.
 * Only returns true on the software-boards, software-backlog, and software-list routes
 * within the software subproduct.
 */
export const useIsRovoOnboardingTargetRoute = (): boolean => {
	const isTargetRouteName = useIsTargetRouteName();
	const subProduct = useSubProduct();

	return isTargetRouteName && subProduct === 'software';
};
